import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import order from './/modules/order'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {     
      user,
      order


    },
    // 定义全局getters 方便访问user 模块的roles
    getters:{
    }
  })


// WEBPACK FOOTER //
// ./src/store/index.js